import React from "react";
import { FieldDefinition } from "../../types/fieldDefinitions";
import { RvDto } from "../../types/rv";

interface AppointmentFormFieldsProps {
  fields: readonly FieldDefinition[];
  formData: Partial<RvDto>;
  onChange: (name: keyof RvDto, value: any) => void;
}

export const AddAppointmentFields: React.FC<AppointmentFormFieldsProps> = ({
  fields,
  formData,
  onChange,
}) => {
  const visibleFields = fields.filter(
    (f) => f.name !== "patientId" && f.name !== "doctorId",
  );

  return (
    <div className="grid grid-cols-2 gap-4 pt-2">
      {visibleFields.map((field) => {
        const fieldName = field.name as keyof RvDto;
        const value = formData[fieldName] ?? "";

        return (
          <div
            key={String(field.name)}
            className={field.name === "rvReason" ? "col-span-2" : ""}
          >
            <label className="block text-sm font-medium text-gray-700">
              {field.label}{" "}
              {field.required && <span className="text-red-500">*</span>}
            </label>

            {/* ΕΛΕΓΧΟΣ: Αν ο τύπος είναι select, δείξε <select>, αλλιώς κανονικό <input> */}
            {field.type === "select" ? (
              <select
                required={field.required}
                value={value as string | number}
                onChange={(e) => onChange(fieldName, Number(e.target.value))}
                className="w-full mt-1 p-2 border rounded-lg text-sm bg-white focus:ring-2 focus:ring-primary focus:outline-none"
              >
                {field.options?.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type={field.type}
                required={field.required}
                value={value as string | number}
                onChange={(e) =>
                  onChange(
                    fieldName,
                    field.type === "number"
                      ? e.target.value === ""
                        ? undefined
                        : Number(e.target.value)
                      : e.target.value,
                  )
                }
                className="w-full mt-1 p-2 border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:outline-none"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
